import React, { Fragment, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

import PostContext from "../../context/post/postContext";

import CircularProgress from "@material-ui/core/CircularProgress";
import CardMedia from '@mui/material/CardMedia';
import MobileStepper from "@material-ui/core/MobileStepper";
import Paper from "@material-ui/core/Paper";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { makeStyles, useTheme } from "@material-ui/core/styles";

import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";


const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: "flex",
    alignItems: "center",
    // height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    // height: 255,
    display: "block",
    // maxWidth: 400,
    overflow: "hidden",
    width: "100%",
  },
}));

const Carousel = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const postContext = useContext(PostContext);

  const { posts, getPosts, loading } = postContext;

  const maxPhotoNum = props.maxPhotoNum;

  useEffect(() => {
    getPosts();
    //eslint-disable-next-line
  }, []);

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  // gallery posts are those with cover photo and favoriated, 
  // up to 5 ordered from the latest to oldest
  const gallery_posts = posts.filter((post) => {
    return post.cover_photo !== undefined && post.cover_photo !== null && post.is_favorite === true;
  });

  const maxSteps = gallery_posts.length < maxPhotoNum ? gallery_posts.length : maxPhotoNum;

  if (loading) {
      return <CircularProgress />;
  }

  if ((gallery_posts !== null && gallery_posts.length === 0) && !loading) {
    return (
      <Fragment>
      </Fragment>
    );
  } 

  return (
    <div className={classes.root}>
      <Paper square elevation={0} className={classes.header}>
        <Typography>{gallery_posts[activeStep].title}</Typography>
      </Paper>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {gallery_posts.map((step, index) => (
          <div key={step.title}>
            {Math.abs(activeStep - index) <= 2 ? (
              <CardMedia
                className={classes.img}
                image={step.cover_photo.image_link}
                alt={step.title}
                style={{ height: "300px", width: "100%" }}
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="text"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </div>
  );
};

Carousel.propTypes = {
  maxPhotoNum: PropTypes.number.isRequired,
};

export default Carousel;
